/*
 * @Author: your name
 * @Date: 2020-11-16 10:10:02
 * @LastEditTime: 2021-01-11 22:41:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Utils.js
 */
import * as THREE from 'three'
import { Vector2 } from 'three'
import { Dropdown } from 'view-design'
export function perfixInt (num, length) {
  return (Array(length).join(0) + String(num)).slice(-length)
}

export function coverImagePath (root, quality, idxLen, cpointIdx, faceid) {
  return [root, getPlatform().platform, quality, `location_${perfixInt(cpointIdx, idxLen)}_${faceid}`].join('/')
}

export function getPlatform () {
  const ua = window.navigator.userAgent
  if (ua.match(/Mobile/)) {
    // TODO:进一步判断移动端浏览器
    return {
      platform: 'mobile',
      browser: ''
    }
  } else {
    // TODO:进一步判断PC端浏览器
    return {
      platform: 'pc',
      browser: 'Chrome'
    }
  }
}

export async function waitFor (timeout) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, timeout)
  })
}

/**
 *
 * @param {any[]} array 数组
 */
export function arrayToString (array) {
  return String(array)
}

/**
 * 字符串转为number[] 类型
 * @param {string} str 字符串
 * @returns {number[]} 数组类型
 */
export function strToNumberArray (str) {
  return strToStrArray(str).map(k => Number(k))
}

/**
 * 字符串转为string[] 类型
 * @param {string} str 字符串
 * @returns {string[]} 数组类型
 */
export function strToStrArray (str) {
  if (str[0] === '[') {
    str = str.substr(1, str.length - 2)
  }
  return str.split(',')
}

/**
 *
 * @param {number[][]} matrix
 */
export function matrixToString (matrix) {
  const ls = matrix.map(item => String(item)).join('-')
  return ls
}

/**
 *
 * @param {string} str
 */
export function strToMatrix (str) {
  const mat = str.split('-').map(item => item.split(',').map(i => Number(i)))
  return mat
}

export const WindowsUtls = {
  pop: null,
  close: null,
  getMediaLen: null
}

export function isSingleView (idx) {
  return idx > 1000
}

/**
 *
 * @param {THREE.Matrix4} mtx 矩阵
 * @param {THREE.Vector3} vec 方向
 */
export function getFace (mtx, vec) {
  const rtMtx = new THREE.Matrix4().extractRotation(mtx)
  const dir = vec.clone().applyMatrix4(rtMtx)

  if (Math.abs(dir.x) >= Math.abs(dir.z)) {
    if (dir.x > 0) {
      return 1
    } else {
      return 3
    }
  } else {
    if (dir.z > 0) {
      return 2
    } else {
      return 4
    }
  }
}

/**
 * 生成meshY，点位在地板上的高度值
 * @param {CameraPoint[]} cameraPoints 非单场景点的点位位置列表
 * @param {number} numPoints 点位个数
 * @param {THREE.Object3D[]} objects 模型各个部分列表，用作射线检测
 * @returns {number[]} meshYList 对应pointFloor
 */
export function initMeshY (cameraPoints, numPoints, objects) {
  console.log('开始获取meshY')
  const meshYList = new Array(numPoints)
  const raycaster = new THREE.Raycaster()
  const downDir = new THREE.Vector3(0, -1, 0)
  for (let i = 0; i < numPoints; ++i) {
    raycaster.set(cameraPoints[i].position, downDir) // 设置射线源和方向
    const intersects = raycaster.intersectObjects(objects) // objects为加载模型时得到的分组
    if (intersects.length > 0) {
      meshYList[i] = intersects[0].point.y // 第一个相交的点的y坐标
    } else {
      console.error('没射到地板，或者地板镂空了')
    }
  }
  console.log('meshY填充完毕')
  return meshYList
}

/**
 * 生成邻接矩阵
 * @param {CameraPoint[]} cameraPoints 非单场景点的点位位置列表
 * @param {number} numPoints 点位个数
 * @param {THREE.Object3D[]} objects 模型各个部分列表，用作射线检测
 * @returns {number[][]} MGraph 邻接矩阵
 */
export function initMGraph (cameraPoints, numPoints, objects) {
  console.log('开始生成邻接矩阵')
  const MGraph = new Array(numPoints)
  for (let i = 0; i < MGraph.length; ++i) {
    MGraph[i] = new Array(numPoints)
  }

  for (let i = 0; i < numPoints; ++i) { // numPoints是所有模型内点位数量，不包括单场景点
    for (let j = 0; j < numPoints; ++j) {
      if (i < j) {
        MGraph[i][j] = edge(cameraPoints[i].position, cameraPoints[j].position, objects) // MGraph为目标邻接矩阵
      } else if (i === j) {
        MGraph[i][j] = 0
      } else if (i > j) {
        MGraph[i][j] = MGraph[j][i]
      }
    }
  }
  console.log('邻接矩阵填充完毕')
  return MGraph
}

/**
 * 计算两点间的距离，若有遮挡则为65535
 * @param {THREE.Vector3} point1 点位1
 * @param {THREE.Vector3} point2 点位2
 * @param {THREE.Object3D[]} objects 模型各个部分列表
 */
export function edge (point1, point2, objects) {
  const dir = new THREE.Vector3()
  dir.subVectors(point2, point1)
  const raycasterE = new THREE.Raycaster(point1, dir.clone().normalize())
  const intersects = raycasterE.intersectObjects(objects) // objects为加载模型时得到的分组
  if (intersects.length > 0) {
    // dir.length为两点间距离，intersects.distance表示射线源与模型的距离
    if (intersects[0].distance < dir.length()) {
      return 65535 // 跟模型距离比点距离短，有阻碍物，不是边
    }
  } else {
    // console.log('两点位之间没有障碍物')
  }
  return dir.length() // 射线无阻挡或在很远才与模型相交，两点连同
}
